// extracted by mini-css-extract-plugin
module.exports = {"specialty":"styles-module__specialty___10dkc","content":"styles-module__content___39f7M"};